import React, { Component } from 'react';
import '../assets/css/nav.css';
import { Link } from 'react-router-dom';
import logoBlack from '../cocoroboB.svg';
import logoWhite from '../cocoroboW.svg';
import vimeo from '../assets/img/nav_vimeo.svg';
import config from '../config';
//plugin
import Pace from 'react-top-loading-bar';
import { observer } from 'mobx-react';
import axios from 'axios';



let homepage = config.basename;

@observer
class Nav extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			currentTarget: '',
			isToggleOpen: false,
			redirectToProduct: false,
			redirectToCurriculum: false,
			redireactToCompetition: false
		}
		this.checkLoginState = this.checkLoginState.bind(this);
	}
	checkLoginState() {
		let self = this;
		axios.defaults.withCredentials = true;
		axios.get(config.server + '/api/state')
			.then(function (res) {
				if (res.data == 'Logged') {
					self.props.userStore.login = true;
				} else {
					self.props.userStore.login = false;
				}
			})
			.catch(function (err) {
				console.log(err);
			})
	}
	hamburgerClick() {
		this.setState({
			isToggleOpen: !this.state.isToggleOpen
		})
		let hamburgerButton = document.getElementById('hamburger');
		let state = hamburgerButton.getAttribute('state');
		//change logo Style
		//special issue in homepage
		if (window.location.pathname === homepage && state === 'closed') {
			document.querySelectorAll('.logo')[0].children[0].setAttribute('src', logoBlack);
		} else if (window.location.pathname === homepage && state === 'opened') {
			document.querySelectorAll('.logo')[0].children[0].setAttribute('src', logoWhite);
		}

		if (state === 'closed') {
			document.getElementById('nav').style.display = 'block';
			hamburgerButton.setAttribute('state', 'opened');
			hamburgerButton.children[0].setAttribute('class', 'navButtonOpened');
			hamburgerButton.children[1].setAttribute('class', 'navButtonOpened');
			hamburgerButton.children[2].setAttribute('class', 'navButtonOpened');
		} else {
			document.getElementById('nav').setAttribute('style', '');
			hamburgerButton.setAttribute('state', 'closed');
			hamburgerButton.children[0].setAttribute('class', 'navButton');
			hamburgerButton.children[1].setAttribute('class', 'navButton');
			hamburgerButton.children[2].setAttribute('class', 'navButton');
		}
	}
	homepageClick() {
		let hamburgerButton = document.getElementById('hamburger');
		let state = hamburgerButton.getAttribute('state');
		if (state !== 'closed') {
			document.getElementById('nav').setAttribute('style', '');
			hamburgerButton.setAttribute('state', 'closed');
			hamburgerButton.children[0].setAttribute('class', 'navButton');
			hamburgerButton.children[1].setAttribute('class', 'navButton');
			hamburgerButton.children[2].setAttribute('class', 'navButton');
		}
	}
	hamburgerToggle(event) {
		if (event.target.nodeName === 'LI' && window.innerWidth < 640 && typeof event.target.children[0] === 'undefined') {
			this.hamburgerClick();
		}
	}
	navToggle(event) {
		//if span is exist
		try {
			this.fadeOut(event);
			if (event.target.nodeName === 'SPAN') {
				if (event.target.parentNode.nodeName == "LI") {
					event.target.parentNode.children[1].classList.toggle('navOpen');
				}
				else {
					event.target.parentNode.parentNode.children[1].classList.toggle('navOpen');
				}

			}
			if (event.target.nodeName === 'LI' && event.target.parentNode.id === 'nav') {
				if (typeof document.querySelectorAll('.navOpen')[0] !== 'undefined') {
					document.querySelectorAll('.navOpen')[0].classList.toggle('navOpen')
				}
				event.target.children[1].classList.toggle('navOpen');
			} else if (event.target.nodeName == 'A' && event.target.parentNode.parentNode.id == 'nav') {
				if (typeof document.querySelectorAll('.navOpen')[0] !== 'undefined') {
					document.querySelectorAll('.navOpen')[0].classList.toggle('navOpen')
				}
				event.target.parentNode.children[1].classList.toggle('navOpen');
			}
		}
		catch (e) {
		}

	}
	navItemToggle(event) {
		if (event.target.nodeName === 'SPAN') {
			// this.clearNavOpen();
			event.target.parentNode.parentNode.children[1].classList.toggle('navOpen');
		} else if (event.target.nodeName === 'A') {
			// this.clearNavOpen();
			event.target.parentNode.children[1].classList.toggle('navOpen');
		} else if (event.target.nodeName === 'LI') {
			this.hamburgerToggle(event);
		}
	}
	clearNavOpen() {
		if (typeof document.querySelectorAll('.navOpen')[0] !== 'undefined') {
			document.querySelectorAll('.navOpen')[0].classList.toggle('navOpen')
		}
	}
	fadeOut(event) {
		if (typeof document.querySelectorAll('.navOpen')[0] !== 'undefined') {
			document.querySelectorAll('.navOpen')[0].classList.toggle('navOpen')
		}
	}
	render() {
		return (
			<nav className={`${this.props.uiStore.isHomepage ? 'nav' : 'nav navDark'} ${this.props.uiStore.windowWidth < 640 && this.state.isToggleOpen ? 'nav--active' : ''}`}>
				{this.props.userStore.isLoading ? <Pace color="rgb(126, 206, 253)" height={3} /> : ''}
				<Link
					to={this.state.isToggleOpen ? '#' : '/'}
					className='logo'
					onClick={this.state.isToggleOpen ? null : this.homepageClick.bind(this)}
				>
					<img src={this.props.uiStore.isHomepage ? logoWhite : logoBlack} alt="logo" align='left' />
				</Link>
				<div className='navWrapper'>
					<div id='hamburger' state='closed' onClick={this.hamburgerClick.bind(this)}>
						<span className='navButton'></span>
						<span className='navButton'></span>
						<span className='navButton'></span>
					</div>
					<ul
						id='nav'
						className='navList font'
						onClick={this.props.uiStore.windowWidth > 640 ? this.navToggle.bind(this) : null}
					//onClick={this.props.uiStore.windowWidth < 640 ? this.navItemToggle.bind(this) : null}
					>
						{/*<ul id='nav' className='navList font' onMouseOver={window.innerWidth > 640 ? this.navToggle.bind(this) : null} onClick={this.hamburgerToggle.bind(this)}>*/}
						<li >
							<Link to={window.innerWidth < 640 ? '#' : '/product'} style={{ display: 'block', width: '100%' }}><span>產品</span></Link>
							<div className='navDropdown'>
								<ul >
									{/*<Link to='/product'><li className='Nav__anchor'>產品簡介</li></Link>*/}
									<Link to='/cocomod'><li id='cocomod' className='Nav__anchor'>電子模組</li></Link>
									<Link to='/cocokit'><li id='cocokit' className='Nav__anchor'>課程套件</li></Link>
									<Link to='/demoShow'><li id='demoShow' className='Nav__anchor'>demo 展示</li></Link>
									{/*<Link to='/consumables'><li id='consumables' className='Nav__anchor'>打印耗材</li></Link>*/}
								</ul>
							</div>
						</li>
						<a href='//cocorobo.hk/cocopi/' target='_blank'><li>CocoPi</li></a>
						<a href='//edu.cocorobo.hk' target='_blank'><li>課程</li></a>
						<a href='//cocorobo.hk/ai' target='_blank'><li>智啓學教</li></a>
						{/*<li onMouseLeave={this.props.uiStore.windowWidth>640?this.fadeOut.bind(this):null}>
									<a href='//edu.cocorobo.hk' style={{display:'block',width:'100%'}}><span>課程</span></a>
									<div className='navDropdown'>
										<ul onMouseLeave = {this.props.uiStore.windowWidth > 640 ? this.fadeOut.bind(this) : null}>
											<Link to='/curriculum'><li className='Nav__anchor'>課程簡介</li></Link>
											<Link to='/curriculumKit/0'><li id='curriculumKit' className='Nav__anchor'>課程中心</li></Link>
										</ul>
									</div>
								</li>*/}
						{/*<li onMouseLeave={this.props.uiStore.windowWidth>640?this.fadeOut.bind(this):null}>
									<Link to='#' style={{display:'block',width:'100%'}}><span>教程</span></Link>
									<div className='navDropdown'>
										<ul onMouseLeave = {this.props.uiStore.windowWidth > 640 ? this.fadeOut.bind(this) : null}>
											<a href='//help.cocorobo.hk' target='_blank'><li className='Nav__anchor'>幫助文檔</li></a>
											<Link to='/tutor'><li className='Nav__anchor'>在線教學</li></Link>
										</ul>
									</div>
								</li>*/}
						{/*<li >
							<Link to={window.innerWidth < 640 ? '#' : '/curriculum'} style={{ display: 'block', width: '100%' }}><span>服務</span></Link>
							<div className='navDropdown'>
								<ul >
									<Link to='/curriculum'><li className='Nav__anchor'>課程簡介</li></Link>
									<Link to='/service'><li>教學</li></Link>
									<Link to='/print'><li>3D打印</li></Link>
								</ul>
							</div>
						</li>*/}
						<li >
							<a href='//gba.cocorobo.hk' target='_blank'>活动</a>
							{/*
							<Link to={window.innerWidth < 640 ? '#' : '/event'} style={{ display: 'block', width: '100%' }}><span>活動</span></Link>
							<div className='navDropdown'>
								<ul >
									<Link to='/competition'><li>賽事</li></Link>
									<Link to='/workshop'><li>工作坊</li></Link>
								</ul>
							</div>
							*/}
						</li>

						{/* <a href='https://vimeo.com/cocorobo' target='_blank'><li>視頻</li></a> */}
						{/*<Link to='/order' style={{display:'block',width:'100%'}}><li id='nav__order'>採購</li></Link>*/}

						<li >
							<Link to={window.innerWidth < 640 ? '#' : '/event'} style={{ display: 'block', width: '100%' }}><span>創作</span></Link>
							<div className='navDropdown'>
								<ul >
									<Link to='/create' style={{ display: 'block', width: '100%' }}><li>創作</li></Link>
									<Link to='/download' style={{ display: 'block', width: '100%' }}><li>下載</li></Link>
								</ul>
							</div>
						</li>

						{this.props.userStore.login ?
							<li >
								<Link to='/profile' style={{ display: 'block', width: '100%' }}><span>{this.props.userStore.alias}</span></Link>
								<div className='navDropdown'>
									<ul >
										<Link to='/profile'><li>編輯資料</li></Link>
										{/* <Link to='/orderQuery'><li>我的訂單</li></Link> */}
										<Link to='/logout'><li>登出</li></Link>
									</ul>
								</div>
							</li>
							: <li >
								<Link to={window.innerWidth < 640 ? '#' : '#'} style={{ display: 'block', width: '100%' }}><span>學術研究</span></Link>
								<div className='navDropdown'>
									<ul >
										<Link to='//cocorobo.hk/research' target='_blank'><li>研究成果</li></Link>
										<Link to='//cocorobo.hk/smart' target='_blank'><li>SMART原則</li></Link>
										<Link to='//cocorobo.hk/science' target='_blank'><li>小學科學</li></Link>
									</ul>
								</div>
							</li>

						}
						{/*
						<a href='//cocorobo.hk/kexue' target='_blank'><li>學術研究</li></a>
						<li onMouseLeave={this.fadeOut.bind(this)}>
									<span>探索</span>
									<div className={this.state.active && this.state.currentTarget === '探索'? 'navDropdown navOpen':'navDropdown'}>
										<ul onMouseLeave = {this.fadeOut.bind(this)}>
											<Link to='/guide/blockly'><li>教程</li></Link>
											<Link to='/discover/project'><li>發現</li></Link>
											<a href='http://cocorobo.hk/wiki/doku.php?id=wiki' target='_blank'><li>Wiki</li></a>
										</ul>
									</div>
								</li>*/}
						{/*<Link to='/explore'><li>探索</li></Link>*/}
						{/* <a href="#"><li>商城</li></a> */}
						{/*<a href="#" uk-tooltip='title:即將開放;pos:bottom'><li>登入</li></a>*/}
					</ul>
				</div>
			</nav>
		)
	}
}

export default Nav;
